<template>
    <div>
        <div class="row justify-content-end mb-3">
            
            <div class="col-lg-5 col-md-5 col-sm-12">
                <select name="types" class="form-control" v-model="selectedType" @change="resizeAllMasonryItems">
                    <option value="-1">-- {{ $t('todos') }} --</option>
                    <option v-for="(item, index) in itemsToSelect" v-bind:key="index" v-bind:value="item.tipoAnuncio">
                        {{ item.descTipoAnuncio }}</option>
                </select>
            </div>
        </div>
        <div class="row grid-columns" :class="{ visible: visibleMasonry, invisible: !visibleMasonry }">
            <div class="col">
                <Items :items="itemsToMasonry1" @itemsLoaded="itemsLoaded" :tipos="itemsToSelect" />
            </div>
            <div class="col d-none d-sm-block">
                <Items :items="itemsToMasonry2" :tipos="itemsToSelect" />
            </div>
            <div class="col d-none d-lg-block">
                <Items :items="itemsToMasonry3" :tipos="itemsToSelect" />
            </div>
            <div class="col d-none d-xl-block">
                <Items :items="itemsToMasonry4" :tipos="itemsToSelect" />
            </div>
        </div>
        <div v-if="!visibleMasonry">
            <div class="info-card playing">
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="wave"></div>
                <div class="contenido d-flex align-items-center mt-5">
                    <div class="loader d-flex justify-content-center position-relative">
                        <div class="loaderMiniContainer d-flex align-items-center position-relative">
                            <div class="barContainer d-flex flex-column">
                                <span class="bar"></span>
                                <span class="bar bar2"></span>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 101 114"
                                class="svgIcon position-absolute">
                                <circle stroke-width="7" stroke="black" transform="rotate(36.0692 46.1726 46.1727)"
                                    r="29.5497" cy="46.1727" cx="46.1726"></circle>
                                <line stroke-width="7" stroke="black" y2="111.784" x2="97.7088" y1="67.7837"
                                    x1="61.7089"></line>
                            </svg>
                        </div>
                    </div>
                    <div class="info-text theme-dark">
                        <br>{{ $t('atencion') }}<br>
                        <div class="info-text-description">{{ $t('sin_anuncios_alert') }}</div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="addAnuncioModal" size="lg" id="addAnuncioModal" :header-class="'modal-header-color'" static>
            <template v-slot:modal-header>
                <h6 class="modal-title">{{ $t('addAnuncio') }}</h6>
            </template>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="mb-3">
                            <label for="date" class="form-label">Fecha:</label>
                            <mmInputDate v-model="newAnuncio.fecha"></mmInputDate>
                        </div>

                        <div class="mb-3">
                            <label for="date" class="form-label">Hora:</label>
                            <input id="time" type="text" class="form-control" v-model="newAnuncio.hora"
                                @blur="formatTime" />
                        </div>

                        <div class="mb-3">
                            <label for="title" class="form-label">Título:</label>
                            <input type="text" id="title" v-model="newAnuncio.titulo" class="form-control" />
                        </div>

                        <div class="mb-3">
                            <label for="tipoAnuncioDdl" class="form-label">Tipo anuncio:</label>
                            <select id="tipoAnuncioDdl" name="types" class="form-control"
                                v-model="newAnuncio.tipoAnuncio" @change="updateDescAnuncio()">
                                <option v-for="(item, index) in typesAnuncios" v-bind:key="index"
                                    v-bind:value="item.codTipoAnuncio" :default="item.porDefecto === 1">
                                    {{ item.codTipoAnuncio }}</option>
                            </select>
                        </div>

                        <div class="mb-3">
                            <label for="adDesc" class="form-label">Desc. tipo anuncio: </label>
                            <span class="text-info"> {{ newAnuncio.descTipoAnuncio }}</span>
                        </div>

                        <div class="mb-3">
                            <label for="image" class="form-label">Imagen:</label>
                            <input type="file" id="image" class="form-control" @change="handleImageUpload" />
                        </div>

                        <div class="mb-3">
                            <label for="expiry" class="form-label">Fecha de caducidad:</label>
                            <mmInputDate v-model="newAnuncio.fechaCaducidad"></mmInputDate>
                        </div>

                        <small v-if="error" class="text-danger">{{ error }}</small>
                    </div>
                    <div class="col-md-6">
                        <textarea v-model="newAnuncio.anuncio" class="form-control" rows="21"></textarea>
                    </div>
                </div>
                {{ newAnuncio }}
                {{ typesAnuncios }}
            </div>
            <template v-slot:modal-footer>
                <button type="button" class="btn btn-primary waves-effect waves-light btn-submit-success"
                    @click="saveAnuncio">{{ $t('save') }}</button>
                <button type="button" class="btn btn-secondary waves-effect waves-light btn-submit-cancel"
                    v-on:click="$bvModal.hide('addAnuncioModal')">{{ $t('cerrar') }}</button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { dashboardService } from '@/api/dashboard';
import Items from '@/views/tablon/Items.vue'
import { mapGetters } from 'vuex';
import { BModal } from 'bootstrap-vue';
import mmInputDate from '@mysummar/summar-vue/src/components/mmInputDate.vue'

export default {
    name: 'Dashboard',
    data() {
        return {
            items: [],
            itemsToSelect: [],
            selectedType: -1,
            imagePath: process.env.VUE_APP_BASE_API + 'images/dashboard/',
            visibleMasonry: false,
            itemsToMasonry1: [],
            itemsToMasonry2: [],
            itemsToMasonry3: [],
            itemsToMasonry4: [],
            heights: [],
            tipos: [],
            newAnuncio: {
                fecha: '',
                hora: '',
                titulo: '',
                tipoAnuncio: '',
                descTipoAnuncio: '',
                fechaCaducidad: '',
                anuncio: '',
                imagen: null,
            },
            typesAnuncios: [],
            error: '',
        }
    },
    created() {
        window.addEventListener('resize', this.resize);
    },
    computed: {
        ...mapGetters(['getUserData']),
    },
    async mounted() {
        this.items = await dashboardService.getAllNews();
        this.categorias();

        this.itemsToMasonry1 = this.items;
        this.itemsLoaded();
    },
    components: {
        Items,
        BModal,
        mmInputDate
    },
    methods: {
        formatTime() {
            if (this.newAnuncio.hora.length === 6) {
                // Split into HH, mm, ss and format
                const formattedTime = `${this.newAnuncio.hora.slice(0, 2)}:${this.newAnuncio.hora.slice(2, 4)}:${this.newAnuncio.hora.slice(4, 6)}`;
                this.newAnuncio.hora = formattedTime;

                // Validate time range
                const hours = parseInt(this.newAnuncio.hora.slice(0, 2), 10);
                const minutes = parseInt(this.newAnuncio.hora.slice(2, 4), 10);
                const seconds = parseInt(this.newAnuncio.hora.slice(4, 6), 10);

                if (
                    hours > 23 ||
                    minutes > 59 ||
                    seconds > 59
                ) {
                    this.error = 'Invalid time. Please enter a valid HH:mm:ss format.';
                } else {
                    this.error = '';
                }
            } else {
                this.error = 'Please enter 6 digits for HHmmss format.';
            }
        },
        categorias() {

            //sacar las categorias, sin repeticiones
            this.items.map((item, index) => {

                if (this.items.findIndex(e => e.tipoAnuncio == item.tipoAnuncio) === index)
                    this.itemsToSelect.push(item);

                if (item.porDefecto == 1) this.selectedType = item.tipoAnuncio;
            });
        },
        itemsLoaded() {

            if (this.heights.length != this.items.length)
                this.resizeAllMasonryItems();
        },
        //calcula la altura de cada item, y lo coloca en la columna con menor altura
        resizeAllMasonryItems() {
            this.visibleMasonry = false;

            if (this.heights.length == 0) {

                // obtenemos todos los items del dashboard
                let allItems = document.querySelectorAll('.grid-columns > div')[0].getElementsByClassName('grid-item');

                for (var i = 0; i < allItems.length; i++) {
                    this.heights.push({ id: this.items[i].id, height: allItems[i].offsetHeight });
                }
            }

            this.itemsToMasonry1 = [];
            this.itemsToMasonry2 = [];
            this.itemsToMasonry3 = [];
            this.itemsToMasonry4 = [];

            this.visibleMasonry = true;

            let self = this;
            let minHeight;
            let columnToItem = this.itemsToMasonry1;

            this.items.filter((item) => this.selectedType == -1 || this.selectedType == item.tipoAnuncio).forEach(function (item) {
                minHeight = Number.MAX_SAFE_INTEGER;
                [self.itemsToMasonry1, self.itemsToMasonry2, self.itemsToMasonry3, self.itemsToMasonry4].forEach(function (itemsMasonry, index) {

                    if (!self.isHidden(index)) {
                        let h = self.heightColumn(itemsMasonry);
                        if (h < minHeight) {
                            columnToItem = itemsMasonry;
                            minHeight = h;
                        }
                    }
                });

                columnToItem.push(item);
            });
        },
        heightColumn(itemsMasonry) {

            let self = this;
            let h = 0;

            itemsMasonry.forEach(function (item) {
                let element = self.heights.find(elem => elem.id == item.id);
                if (element)
                    h += element.height;
            })

            return h;
        },
        isHidden(index) {

            let column = document.querySelectorAll('.grid-columns > div')[index];
            let style = window.getComputedStyle(column);

            return style.display === 'none';
        },
        resize() {
            this.heights = [];
            this.itemsToMasonry1 = this.items;
        },
        async addAnuncio() {
            this.typesAnuncios = await dashboardService.getAnuncioTypes();
            this.newAnuncio.tipoAnuncio = this.typesAnuncios.find(x => x.porDefecto == 1)?.codTipoAnuncio;
            this.newAnuncio.descTipoAnuncio = this.typesAnuncios.find(x => x.porDefecto == 1)?.descTipoAnuncio;
            var date = new Date();
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();

            this.newAnuncio.fecha = `${day}/${month}/${year}`;
            this.$refs.addAnuncioModal.show();
        },
        updateDescAnuncio() {
            const selectedItem = this.typesAnuncios.find(item => item.codTipoAnuncio === this.newAnuncio.tipoAnuncio);
            this.newAnuncio.descTipoAnuncio = selectedItem.descTipoAnuncio;
            this.$set(this.newAnuncio, 'descTipoAnuncio', selectedItem.descTipoAnuncio);
        },
        handleImageUpload(event) {
            const fileInput = event.target;
            const file = event.target.files[0];
            if (file) {
                const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
                if (!validImageTypes.includes(file.type)) {
                    alert('Please upload a valid image file (JPEG, PNG, or GIF)');
                    this.clearFileInput(fileInput);
                    return;
                }

                const maxSize = 4 * 1024 * 1024; //4MB
                if (file.size > maxSize) {
                    alert('File size must not exceed 2 MB');
                    this.clearFileInput(fileInput);
                    return;
                }

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.newAnuncio.imagen = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        clearFileInput(fileInput) {
            fileInput.value = '';
            this.newAnuncio.imagen = null;
        },
        async saveAnuncio() {
            var base64String = '';
            if (this.newAnuncio.imagen != null)
                base64String = this.newAnuncio.imagen.substr(this.newAnuncio.imagen.indexOf(',') + 1);

            if (dashboardService.postNewAnuncio(this.newAnuncio, base64String)){
                this.$refs.addAnuncioModal.hide();

                location.reload();
            }
        }        
    }
}
</script>

<style>
.grid-columns.visible .grid-item {
    animation: Items 600ms ease-in forwards;
}

@keyframes Items {
    0% {
        opacity: 0;
        transform: scale(0.7) rotateY(90deg);
    }

    60% {
        transform: scale(1.1);
    }

    90% {
        transform: scale(1);
    }

    100% {
        opacity: 1;
    }
}

.info-card {
    margin: 3% auto;
    background: transparent;
    box-shadow: 0px 8px 28px -9px rgba(0, 0, 0, 0.178);
    position: relative;
    width: 60%;
    height: 220px;
    overflow: hidden;
}

.wave {
    position: absolute;
    width: 220%;
    height: 700px;
    opacity: 0.03;
    left: 0;
    top: 0;
    margin-left: -50%;
    margin-top: -70%;
    background: linear-gradient(744deg, rgb(3, 94, 192), rgb(3, 94, 192) 60%, rgb(3, 94, 192));
}

.info-text {
    background-color: transparent;
    font-weight: bold;
    width: 70%;
}

.info-text-description {
    font-weight: lighter;
}

.wave:nth-child(2),
.wave:nth-child(3) {
    top: 210px;
}

.playing .wave {
    border-radius: 40%;
    animation: wave 300000ms infinite linear;
}

.wave {
    border-radius: 40%;
    animation: wave 55s infinite linear;
}

.playing .wave:nth-child(2) {
    animation-duration: 95000ms;
}

.wave:nth-child(2) {
    animation-duration: 500s;
}

.playing .wave:nth-child(3) {
    animation-duration: 100000ms;
}

.wave:nth-child(3) {
    animation-duration: 45s;
}

@keyframes wave {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loader {
    top: 50%;
    left: 3%;
    margin-right: 5%;
    width: 20%;
}

.loaderMiniContainer {
    width: 80%;
    height: fit-content;
}

.barContainer {
    width: 100%;
    height: fit-content;
    gap: 10px;
}

.bar {
    width: 100%;
    height: 5px;
    background: linear-gradient(to right,
            #007bff,
            #9dccfd88,
            #007bff);
    background-size: 200% 100%;
    border-radius: 10px;
    animation: bar ease-in-out 3s infinite alternate-reverse;
}

@keyframes bar {
    0% {
        background-position: left;
    }

    100% {
        background-position: right;
    }
}

.bar2 {
    width: 50%;
}

.svgIcon {
    position: absolute;
    left: -25%;
    margin-top: 20%;
    z-index: 2;
    width: 70%;
    animation: search ease-in-out 3s infinite alternate-reverse;
}

@keyframes search {
    0% {
        transform: translateX(0%) rotate(70deg);
    }

    100% {
        transform: translateX(90%) rotate(10deg);
    }
}

.svgIcon circle,
line {
    stroke: #007bff;
}

.svgIcon circle {
    fill: rgba(56, 88, 119, 0.226)
}
</style>